/**
 * Blog Articles Database
 * 20 articles × 8 languages = 160 URLs
 * 
 * Structure:
 * - Pillar page links to all clusters
 * - Each cluster article links to pillar + related articles + tools
 */

export const BLOG_CATEGORIES = {
  calcolo: {
    it: 'Calcolo',
    en: 'Calculation',
    de: 'Berechnung',
    fr: 'Calcul',
    es: 'Cálculo',
    pt: 'Cálculo',
    ro: 'Calcul',
    pl: 'Obliczanie'
  },
  tecnico: {
    it: 'Aspetti Tecnici',
    en: 'Technical',
    de: 'Technisches',
    fr: 'Technique',
    es: 'Técnico',
    pt: 'Técnico',
    ro: 'Tehnic',
    pl: 'Techniczne'
  },
  documenti: {
    it: 'Documenti',
    en: 'Documents',
    de: 'Dokumente',
    fr: 'Documents',
    es: 'Documentos',
    pt: 'Documentos',
    ro: 'Documente',
    pl: 'Dokumenty'
  },
  speciali: {
    it: 'Casi Speciali',
    en: 'Special Cases',
    de: 'Sonderfälle',
    fr: 'Cas Spéciaux',
    es: 'Casos Especiales',
    pt: 'Casos Especiais',
    ro: 'Cazuri Speciale',
    pl: 'Przypadki Specjalne'
  },
  pratico: {
    it: 'Guide Pratiche',
    en: 'Practical Guides',
    de: 'Praktische Anleitungen',
    fr: 'Guides Pratiques',
    es: 'Guías Prácticas',
    pt: 'Guias Práticos',
    ro: 'Ghiduri Practice',
    pl: 'Praktyczne Poradniki'
  }
};

// Article slugs per language
export const ARTICLE_SLUGS = {
  // Cluster: Calcolo (5 articles)
  'come-calcolare-codice-fiscale': {
    it: 'come-calcolare-codice-fiscale',
    en: 'how-to-calculate-tax-code',
    de: 'steuernummer-berechnen',
    fr: 'comment-calculer-code-fiscal',
    es: 'como-calcular-codigo-fiscal',
    pt: 'como-calcular-codigo-fiscal',
    ro: 'cum-calculezi-codul-fiscal',
    pl: 'jak-obliczyc-numer-podatkowy'
  },
  'codice-fiscale-stranieri': {
    it: 'codice-fiscale-stranieri',
    en: 'tax-code-foreigners',
    de: 'steuernummer-auslaender',
    fr: 'code-fiscal-etrangers',
    es: 'codigo-fiscal-extranjeros',
    pt: 'codigo-fiscal-estrangeiros',
    ro: 'cod-fiscal-straini',
    pl: 'numer-podatkowy-obcokrajowcy'
  },
  'codice-fiscale-neonati': {
    it: 'codice-fiscale-neonati',
    en: 'tax-code-newborns',
    de: 'steuernummer-neugeborene',
    fr: 'code-fiscal-nouveau-nes',
    es: 'codigo-fiscal-recien-nacidos',
    pt: 'codigo-fiscal-recem-nascidos',
    ro: 'cod-fiscal-nou-nascuti',
    pl: 'numer-podatkowy-noworodki'
  },
  'documenti-codice-fiscale': {
    it: 'documenti-codice-fiscale',
    en: 'documents-tax-code',
    de: 'dokumente-steuernummer',
    fr: 'documents-code-fiscal',
    es: 'documentos-codigo-fiscal',
    pt: 'documentos-codigo-fiscal',
    ro: 'documente-cod-fiscal',
    pl: 'dokumenty-numer-podatkowy'
  },
  'errori-calcolo-codice-fiscale': {
    it: 'errori-calcolo-codice-fiscale',
    en: 'tax-code-calculation-errors',
    de: 'fehler-steuernummer-berechnung',
    fr: 'erreurs-calcul-code-fiscal',
    es: 'errores-calculo-codigo-fiscal',
    pt: 'erros-calculo-codigo-fiscal',
    ro: 'erori-calcul-cod-fiscal',
    pl: 'bledy-obliczania-numeru'
  },
  
  // Cluster: Tecnico (5 articles)
  'omocodia-spiegata': {
    it: 'omocodia-spiegata',
    en: 'omocodia-explained',
    de: 'omocodia-erklaert',
    fr: 'omocodia-expliquee',
    es: 'omocodia-explicada',
    pt: 'omocodia-explicada',
    ro: 'omocodia-explicata',
    pl: 'omokodia-wyjasnienie'
  },
  'carattere-controllo-cin': {
    it: 'carattere-controllo-cin',
    en: 'control-character-cin',
    de: 'kontrollzeichen-cin',
    fr: 'caractere-controle-cin',
    es: 'caracter-control-cin',
    pt: 'caracter-controle-cin',
    ro: 'caracter-control-cin',
    pl: 'znak-kontrolny-cin'
  },
  'codici-catastali-comuni': {
    it: 'codici-catastali-comuni',
    en: 'cadastral-codes-municipalities',
    de: 'katastercodes-gemeinden',
    fr: 'codes-cadastraux-communes',
    es: 'codigos-catastrales-municipios',
    pt: 'codigos-cadastrais-municipios',
    ro: 'coduri-cadastrale-comune',
    pl: 'kody-katastralne-gminy'
  },
  'differenza-codice-fiscale-partita-iva': {
    it: 'differenza-codice-fiscale-partita-iva',
    en: 'difference-tax-code-vat-number',
    de: 'unterschied-steuernummer-umsatzsteuer',
    fr: 'difference-code-fiscal-tva',
    es: 'diferencia-codigo-fiscal-iva',
    pt: 'diferenca-codigo-fiscal-nif',
    ro: 'diferenta-cod-fiscal-tva',
    pl: 'roznica-numer-podatkowy-vat'
  },
  'struttura-codice-fiscale': {
    it: 'struttura-codice-fiscale',
    en: 'tax-code-structure',
    de: 'struktur-steuernummer',
    fr: 'structure-code-fiscal',
    es: 'estructura-codigo-fiscal',
    pt: 'estrutura-codigo-fiscal',
    ro: 'structura-cod-fiscal',
    pl: 'struktura-numeru-podatkowego'
  },
  
  // Cluster: Documenti (4 articles)
  'tessera-sanitaria-guida': {
    it: 'tessera-sanitaria-guida',
    en: 'health-card-guide',
    de: 'gesundheitskarte-anleitung',
    fr: 'carte-sante-guide',
    es: 'tarjeta-sanitaria-guia',
    pt: 'cartao-saude-guia',
    ro: 'card-sanatate-ghid',
    pl: 'karta-zdrowia-przewodnik'
  },
  'tessera-sanitaria-europea-team': {
    it: 'tessera-sanitaria-europea-team',
    en: 'european-health-card-ehic',
    de: 'europaeische-krankenversicherungskarte',
    fr: 'carte-europeenne-assurance-maladie',
    es: 'tarjeta-sanitaria-europea',
    pt: 'cartao-europeu-saude',
    ro: 'card-european-sanatate',
    pl: 'europejska-karta-zdrowia'
  },
  'codice-fiscale-carta-identita': {
    it: 'codice-fiscale-carta-identita',
    en: 'tax-code-id-card',
    de: 'steuernummer-personalausweis',
    fr: 'code-fiscal-carte-identite',
    es: 'codigo-fiscal-dni',
    pt: 'codigo-fiscal-cartao-cidadao',
    ro: 'cod-fiscal-carte-identitate',
    pl: 'numer-podatkowy-dowod'
  },
  'codice-fiscale-spid': {
    it: 'codice-fiscale-spid',
    en: 'tax-code-digital-identity',
    de: 'steuernummer-digitale-identitaet',
    fr: 'code-fiscal-identite-numerique',
    es: 'codigo-fiscal-identidad-digital',
    pt: 'codigo-fiscal-identidade-digital',
    ro: 'cod-fiscal-identitate-digitala',
    pl: 'numer-podatkowy-tozsamosc-cyfrowa'
  },
  
  // Cluster: Casi Speciali (4 articles)
  'codice-fiscale-cittadini-ue': {
    it: 'codice-fiscale-cittadini-ue',
    en: 'tax-code-eu-citizens',
    de: 'steuernummer-eu-buerger',
    fr: 'code-fiscal-citoyens-ue',
    es: 'codigo-fiscal-ciudadanos-ue',
    pt: 'codigo-fiscal-cidadaos-ue',
    ro: 'cod-fiscal-cetateni-ue',
    pl: 'numer-podatkowy-obywatele-ue'
  },
  'codice-fiscale-provvisorio': {
    it: 'codice-fiscale-provvisorio',
    en: 'temporary-tax-code',
    de: 'vorlaeufige-steuernummer',
    fr: 'code-fiscal-provisoire',
    es: 'codigo-fiscal-provisional',
    pt: 'codigo-fiscal-provisorio',
    ro: 'cod-fiscal-provizoriu',
    pl: 'tymczasowy-numer-podatkowy'
  },
  'cambio-dati-codice-fiscale': {
    it: 'cambio-dati-codice-fiscale',
    en: 'change-tax-code-data',
    de: 'aenderung-steuernummer-daten',
    fr: 'modification-donnees-code-fiscal',
    es: 'cambio-datos-codigo-fiscal',
    pt: 'alteracao-dados-codigo-fiscal',
    ro: 'modificare-date-cod-fiscal',
    pl: 'zmiana-danych-numer-podatkowy'
  },
  'codice-fiscale-deceduti': {
    it: 'codice-fiscale-deceduti',
    en: 'tax-code-deceased',
    de: 'steuernummer-verstorbene',
    fr: 'code-fiscal-defunts',
    es: 'codigo-fiscal-fallecidos',
    pt: 'codigo-fiscal-falecidos',
    ro: 'cod-fiscal-decedati',
    pl: 'numer-podatkowy-zmarlych'
  },
  
  // Cluster: Guide Pratiche (2 articles)
  'verifica-codice-fiscale-online': {
    it: 'verifica-codice-fiscale-online',
    en: 'verify-tax-code-online',
    de: 'steuernummer-online-pruefen',
    fr: 'verifier-code-fiscal-en-ligne',
    es: 'verificar-codigo-fiscal-online',
    pt: 'verificar-codigo-fiscal-online',
    ro: 'verifica-cod-fiscal-online',
    pl: 'weryfikacja-numeru-online'
  },
  'storia-codice-fiscale': {
    it: 'storia-codice-fiscale',
    en: 'history-italian-tax-code',
    de: 'geschichte-steuernummer',
    fr: 'histoire-code-fiscal',
    es: 'historia-codigo-fiscal',
    pt: 'historia-codigo-fiscal',
    ro: 'istoria-codului-fiscal',
    pl: 'historia-numeru-podatkowego'
  }
};

/**
 * Translation completion status for each article
 * Languages with < 80% content parity are marked as 'draft'
 * 'published' = ready for indexing, 'draft' = exclude from sitemap
 * 
 * Status (Jul 2026): all 20 articles are published in all 8 languages.
 * The German set was the last to reach enterprise parity (Wave D).
 */
export const TRANSLATION_STATUS = {
  'come-calcolare-codice-fiscale': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'codice-fiscale-stranieri': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'codice-fiscale-neonati': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'documenti-codice-fiscale': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'errori-calcolo-codice-fiscale': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'omocodia-spiegata': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'carattere-controllo-cin': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'codici-catastali-comuni': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'differenza-codice-fiscale-partita-iva': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'struttura-codice-fiscale': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'tessera-sanitaria-guida': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'tessera-sanitaria-europea-team': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'codice-fiscale-carta-identita': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'codice-fiscale-spid': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'codice-fiscale-cittadini-ue': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'codice-fiscale-provvisorio': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'cambio-dati-codice-fiscale': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'codice-fiscale-deceduti': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'verifica-codice-fiscale-online': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  },
  'storia-codice-fiscale': {
    it: 'published', en: 'published', de: 'published', fr: 'published', es: 'published', pt: 'published', ro: 'published', pl: 'published'
  }
};

// Helper function to check if article is published for a locale
export const isArticlePublished = (articleId, locale) => {
  const status = TRANSLATION_STATUS[articleId];
  if (!status) return true; // Default to published if not in list
  return status[locale] === 'published';
};

// Get all published articles for a specific locale
export const getPublishedArticles = (locale) => {
  return Object.entries(TRANSLATION_STATUS)
    .filter(([_, status]) => status[locale] === 'published')
    .map(([id]) => id);
};

// Full article metadata
export const ARTICLES = [
  // ============ CLUSTER: CALCOLO ============
  {
    id: 'come-calcolare-codice-fiscale',
    category: 'calcolo',
    priority: 1,
    relatedTools: ['calculator', 'verify'],
    relatedArticles: ['errori-calcolo-codice-fiscale', 'struttura-codice-fiscale', 'omocodia-spiegata'],
    externalLinks: [
      { url: 'https://www.agenziaentrate.gov.it/', name: 'Agenzia delle Entrate' }
    ],
    wordCount: 2500,
    readingTime: 12
  },
  {
    id: 'codice-fiscale-stranieri',
    category: 'calcolo',
    priority: 2,
    relatedTools: ['calculator'],
    relatedArticles: ['documenti-codice-fiscale', 'codice-fiscale-cittadini-ue', 'codice-fiscale-provvisorio'],
    externalLinks: [
      { url: 'https://www.agenziaentrate.gov.it/', name: 'Agenzia delle Entrate' },
      { url: 'https://www.interno.gov.it/', name: 'Ministero dell\'Interno' }
    ],
    wordCount: 2200,
    readingTime: 10
  },
  {
    id: 'codice-fiscale-neonati',
    category: 'calcolo',
    priority: 3,
    relatedTools: ['calculator', 'healthCard'],
    relatedArticles: ['documenti-codice-fiscale', 'tessera-sanitaria-guida', 'come-calcolare-codice-fiscale'],
    externalLinks: [
      { url: 'https://www.agenziaentrate.gov.it/', name: 'Agenzia delle Entrate' },
      { url: 'https://www.salute.gov.it/', name: 'Ministero della Salute' }
    ],
    wordCount: 2000,
    readingTime: 9
  },
  {
    id: 'documenti-codice-fiscale',
    category: 'calcolo',
    priority: 4,
    relatedTools: ['calculator'],
    relatedArticles: ['codice-fiscale-stranieri', 'codice-fiscale-neonati', 'codice-fiscale-cittadini-ue'],
    externalLinks: [
      { url: 'https://www.agenziaentrate.gov.it/', name: 'Agenzia delle Entrate' }
    ],
    wordCount: 1800,
    readingTime: 8
  },
  {
    id: 'errori-calcolo-codice-fiscale',
    category: 'calcolo',
    priority: 5,
    relatedTools: ['calculator', 'verify'],
    relatedArticles: ['come-calcolare-codice-fiscale', 'omocodia-spiegata', 'carattere-controllo-cin'],
    externalLinks: [
      { url: 'https://www.agenziaentrate.gov.it/', name: 'Agenzia delle Entrate' }
    ],
    wordCount: 2000,
    readingTime: 9
  },

  // ============ CLUSTER: TECNICO ============
  {
    id: 'omocodia-spiegata',
    category: 'tecnico',
    priority: 6,
    relatedTools: ['calculator', 'verify', 'reverse'],
    relatedArticles: ['struttura-codice-fiscale', 'carattere-controllo-cin', 'come-calcolare-codice-fiscale'],
    externalLinks: [
      { url: 'https://www.agenziaentrate.gov.it/', name: 'Agenzia delle Entrate' },
      { url: 'https://it.wikipedia.org/wiki/Omocodia', name: 'Wikipedia - Omocodia' }
    ],
    wordCount: 2200,
    readingTime: 10
  },
  {
    id: 'carattere-controllo-cin',
    category: 'tecnico',
    priority: 7,
    relatedTools: ['verify'],
    relatedArticles: ['struttura-codice-fiscale', 'omocodia-spiegata', 'errori-calcolo-codice-fiscale'],
    externalLinks: [
      { url: 'https://it.wikipedia.org/wiki/Codice_fiscale', name: 'Wikipedia - Codice Fiscale' }
    ],
    wordCount: 2000,
    readingTime: 9
  },
  {
    id: 'codici-catastali-comuni',
    category: 'tecnico',
    priority: 8,
    relatedTools: ['calculator', 'municipalities'],
    relatedArticles: ['struttura-codice-fiscale', 'come-calcolare-codice-fiscale'],
    externalLinks: [
      { url: 'https://www.agenziaentrate.gov.it/', name: 'Agenzia delle Entrate' },
      { url: 'https://www.istat.it/', name: 'ISTAT' }
    ],
    wordCount: 2000,
    readingTime: 9
  },
  {
    id: 'differenza-codice-fiscale-partita-iva',
    category: 'tecnico',
    priority: 9,
    relatedTools: ['calculator', 'verify'],
    relatedArticles: ['struttura-codice-fiscale', 'documenti-codice-fiscale'],
    externalLinks: [
      { url: 'https://www.agenziaentrate.gov.it/', name: 'Agenzia delle Entrate' }
    ],
    wordCount: 2000,
    readingTime: 9
  },
  {
    id: 'struttura-codice-fiscale',
    category: 'tecnico',
    priority: 10,
    relatedTools: ['calculator', 'reverse', 'verify'],
    relatedArticles: ['come-calcolare-codice-fiscale', 'carattere-controllo-cin', 'omocodia-spiegata'],
    externalLinks: [
      { url: 'https://www.agenziaentrate.gov.it/', name: 'Agenzia delle Entrate' },
      { url: 'https://it.wikipedia.org/wiki/Codice_fiscale', name: 'Wikipedia - Codice Fiscale' }
    ],
    wordCount: 2500,
    readingTime: 11
  },

  // ============ CLUSTER: DOCUMENTI ============
  {
    id: 'tessera-sanitaria-guida',
    category: 'documenti',
    priority: 11,
    relatedTools: ['healthCard', 'calculator'],
    relatedArticles: ['tessera-sanitaria-europea-team', 'codice-fiscale-neonati', 'codice-fiscale-carta-identita'],
    externalLinks: [
      { url: 'https://www.salute.gov.it/', name: 'Ministero della Salute' },
      { url: 'https://sistemats1.sanita.finanze.it/', name: 'Sistema TS' }
    ],
    wordCount: 2200,
    readingTime: 10
  },
  {
    id: 'tessera-sanitaria-europea-team',
    category: 'documenti',
    priority: 12,
    relatedTools: ['healthCard'],
    relatedArticles: ['tessera-sanitaria-guida', 'codice-fiscale-cittadini-ue'],
    externalLinks: [
      { url: 'https://ec.europa.eu/social/main.jsp?catId=559', name: 'European Commission - EHIC' },
      { url: 'https://www.salute.gov.it/', name: 'Ministero della Salute' }
    ],
    wordCount: 2000,
    readingTime: 9
  },
  {
    id: 'codice-fiscale-carta-identita',
    category: 'documenti',
    priority: 13,
    relatedTools: ['calculator'],
    relatedArticles: ['tessera-sanitaria-guida', 'codice-fiscale-spid', 'documenti-codice-fiscale'],
    externalLinks: [
      { url: 'https://www.cartaidentita.interno.gov.it/', name: 'Carta d\'Identità Elettronica' }
    ],
    wordCount: 1800,
    readingTime: 8
  },
  {
    id: 'codice-fiscale-spid',
    category: 'documenti',
    priority: 14,
    relatedTools: ['calculator', 'verify'],
    relatedArticles: ['codice-fiscale-carta-identita', 'documenti-codice-fiscale'],
    externalLinks: [
      { url: 'https://www.spid.gov.it/', name: 'SPID - Sistema Pubblico di Identità Digitale' },
      { url: 'https://www.agid.gov.it/', name: 'AgID' }
    ],
    wordCount: 1800,
    readingTime: 8
  },

  // ============ CLUSTER: CASI SPECIALI ============
  {
    id: 'codice-fiscale-cittadini-ue',
    category: 'speciali',
    priority: 15,
    relatedTools: ['calculator'],
    relatedArticles: ['codice-fiscale-stranieri', 'tessera-sanitaria-europea-team', 'documenti-codice-fiscale'],
    externalLinks: [
      { url: 'https://www.agenziaentrate.gov.it/', name: 'Agenzia delle Entrate' },
      { url: 'https://europa.eu/', name: 'Europa.eu' }
    ],
    wordCount: 2000,
    readingTime: 9
  },
  {
    id: 'codice-fiscale-provvisorio',
    category: 'speciali',
    priority: 16,
    relatedTools: ['calculator'],
    relatedArticles: ['codice-fiscale-stranieri', 'documenti-codice-fiscale', 'codice-fiscale-cittadini-ue'],
    externalLinks: [
      { url: 'https://www.agenziaentrate.gov.it/', name: 'Agenzia delle Entrate' }
    ],
    wordCount: 1800,
    readingTime: 8
  },
  {
    id: 'cambio-dati-codice-fiscale',
    category: 'speciali',
    priority: 17,
    relatedTools: ['calculator', 'verify'],
    relatedArticles: ['documenti-codice-fiscale', 'struttura-codice-fiscale'],
    externalLinks: [
      { url: 'https://www.agenziaentrate.gov.it/', name: 'Agenzia delle Entrate' }
    ],
    wordCount: 2000,
    readingTime: 9
  },
  {
    id: 'codice-fiscale-deceduti',
    category: 'speciali',
    priority: 18,
    relatedTools: ['verify', 'reverse'],
    relatedArticles: ['cambio-dati-codice-fiscale', 'documenti-codice-fiscale', 'tessera-sanitaria-guida', 'verifica-codice-fiscale-online', 'codice-fiscale-spid'],
    externalLinks: [
      { url: 'https://www.agenziaentrate.gov.it/', name: 'Agenzia delle Entrate' },
      { url: 'https://www.inps.it/', name: 'INPS' }
    ],
    wordCount: 1800,
    readingTime: 8
  },

  // ============ CLUSTER: GUIDE PRATICHE ============
  {
    id: 'verifica-codice-fiscale-online',
    category: 'pratico',
    priority: 19,
    relatedTools: ['verify', 'reverse'],
    relatedArticles: ['errori-calcolo-codice-fiscale', 'carattere-controllo-cin', 'omocodia-spiegata'],
    externalLinks: [
      { url: 'https://telematici.agenziaentrate.gov.it/', name: 'Servizi Telematici AdE' }
    ],
    wordCount: 2000,
    readingTime: 9
  },
  {
    id: 'storia-codice-fiscale',
    category: 'pratico',
    priority: 20,
    relatedTools: ['calculator'],
    relatedArticles: ['struttura-codice-fiscale', 'omocodia-spiegata'],
    externalLinks: [
      { url: 'https://it.wikipedia.org/wiki/Codice_fiscale', name: 'Wikipedia - Codice Fiscale' },
      { url: 'https://www.agenziaentrate.gov.it/', name: 'Agenzia delle Entrate' }
    ],
    wordCount: 2500,
    readingTime: 11
  }
];

// Tool mappings for internal links
export const TOOL_LINKS = {
  calculator: {
    it: '/',
    en: '/en',
    de: '/de',
    fr: '/fr',
    es: '/es',
    pt: '/pt',
    ro: '/ro',
    pl: '/pl'
  },
  verify: {
    it: '/verifica',
    en: '/en/verify',
    de: '/de/pruefen',
    fr: '/fr/verifier',
    es: '/es/verificar',
    pt: '/pt/verificar',
    ro: '/ro/verifica',
    pl: '/pl/weryfikuj'
  },
  reverse: {
    it: '/inverso',
    en: '/en/reverse',
    de: '/de/umkehren',
    fr: '/fr/inverse',
    es: '/es/inverso',
    pt: '/pt/inverso',
    ro: '/ro/invers',
    pl: '/pl/odwrotny'
  },
  healthCard: {
    it: '/tessera-sanitaria',
    en: '/en/health-card',
    de: '/de/gesundheitskarte',
    fr: '/fr/carte-sante',
    es: '/es/tarjeta-sanitaria',
    pt: '/pt/cartao-saude',
    ro: '/ro/card-sanatate',
    pl: '/pl/karta-zdrowia'
  },
  municipalities: {
    it: '/comuni',
    en: '/en/municipalities',
    de: '/de/gemeinden',
    fr: '/fr/communes',
    es: '/es/municipios',
    pt: '/pt/municipios',
    ro: '/ro/comune',
    pl: '/pl/gminy'
  }
};

// Blog route mappings
export const BLOG_ROUTES = {
  it: 'blog',
  en: 'en/blog',
  de: 'de/blog',
  fr: 'fr/blog',
  es: 'es/blog',
  pt: 'pt/blog',
  ro: 'ro/blog',
  pl: 'pl/blog'
};

// Helper to get article URL
export const getArticleUrl = (articleId, locale) => {
  const slug = ARTICLE_SLUGS[articleId]?.[locale] || ARTICLE_SLUGS[articleId]?.it;
  const blogPath = BLOG_ROUTES[locale] || BLOG_ROUTES.it;
  return `/${blogPath}/${slug}`;
};

// Helper to get tool URL  
export const getToolUrl = (toolId, locale) => {
  return TOOL_LINKS[toolId]?.[locale] || TOOL_LINKS[toolId]?.it;
};

export default ARTICLES;
